import { render, staticRenderFns } from "./newsletters.vue?vue&type=template&id=65ac9822"
import script from "./newsletters.vue?vue&type=script&lang=ts"
export * from "./newsletters.vue?vue&type=script&lang=ts"
import style0 from "./newsletters.vue?vue&type=style&index=0&id=65ac9822&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports